<template>
  <v-dialog v-model="AddCreditDialog" max-width="1200px" persistent scrollable>
    <v-card>
      <v-form ref="form" v-model="valid" lazy-validation>
        <div v-if="nextPage">
          <v-toolbar dark class="elevation-0" color="primary">
            <v-toolbar-title
              ><h3 style="color: black">Add Credit</h3></v-toolbar-title
            >
            <v-spacer></v-spacer>
            <v-icon @click="cancel()" color="black">close</v-icon>
          </v-toolbar>
          <v-container fluid grid-list-xl class="px-4 pt-4">
            <v-layout wrap align-center>
              <v-layout>
                <v-flex xs3>
                  <v-subheader class="mt-2">Manager Name</v-subheader>
                </v-flex>
                <v-flex xs9 md7>
                  <v-select
                    :rules="[rules.required, rules.counter]"
                    outline
                    :items="setManagerMaintain"
                    outlined
                    v-model="form.managername"
                    item-text="user_partner_name"
                    item-value="user_partner_id"
                    label="Manager Name"
                    :loading="loadingMessage"
                  >
                    ></v-select
                  >
                </v-flex>
              </v-layout>
              <v-layout class="ml-2">
                <v-flex xs2>
                  <v-subheader class="mt-2">Amount</v-subheader>
                </v-flex>
                <v-flex xs10 md8>
                  <v-text-field
                    v-model.number="form.amountcredit"
                    type="number"
                    :rules="[rules.required, rules.counter]"
                    label="Credit"
                    outline
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-layout>
          </v-container>

          <v-toolbar-title class="white d-flex justify-end">
            <v-spacer></v-spacer>
            <v-btn
              class="mb-3"
              @click="nextpage(form.managername)"
              dark
              :loading="loadingMessage"
              >Next</v-btn
            >
            <v-spacer></v-spacer>
          </v-toolbar-title>
        </div>
        <div v-else>
          <div v-if="paynow">
            <v-toolbar dark class="elevation-0" color="primary">
              <v-toolbar-title
                ><h3 style="color: black">Add Credit</h3></v-toolbar-title
              >
              <v-spacer></v-spacer>
              <v-icon @click="cancel()" color="black">close</v-icon>
            </v-toolbar>
            <v-container>
              <v-flex xs12 class="my-2">
                <h3 class="px-0 text-md-center" style="font-size:25px">
                  Are you sure to add credit?
                </h3>
              </v-flex>
              <v-card-text class="mt-2">
                <div>
                  <div>
                    <span style="color: black" class="title"
                      >Manager name :</span
                    >
                    <span class="title">{{
                      " " + setManagerMaintainById.user_partner_name
                    }}</span>
                  </div>
                  <div class="my-3">
                    <span style="color: black" class="title">Province :</span>
                    <span class="title">{{
                      " " +
                        setManagerMaintainById.user_partner_province
                          .province_name_th
                    }}</span>
                  </div>
                  <div class="my-3">
                    <span style="color: black" class="title">District :</span>
                    <span
                      class="title"
                      v-for="(item,
                      idex) in setManagerMaintainById.user_partner_district"
                      :key="idex"
                      >{{ " " + item.district_name_th }}</span
                    >
                  </div>
                  <div>
                    <span style="color: black" class="title">Amount :</span>
                    <span class="title"
                      >{{ " " + form.amountcredit }} Credit</span
                    >
                  </div>
                </div>
              </v-card-text>
            </v-container>
            <v-footer class="white d-flex justify-center my-1">
              <v-spacer></v-spacer>
              <v-btn
                @click="addCreditComfirm()"
                class="mb-4"
                dark
                :loading="loadingMessage"
                >Confirm</v-btn
              >
              <v-spacer></v-spacer>
            </v-footer>
          </div>
          <div v-else>
            <v-toolbar dark class="elevation-0" color="primary">
              <v-toolbar-title
                ><h3 style="color: black">Status</h3></v-toolbar-title
              >
              <v-spacer></v-spacer>
              <v-icon @click="cancel()" color="black">close</v-icon>
            </v-toolbar>
            <v-container grid-list-md text-xs-center>
              <v-layout row wrap>
                <v-flex xs12 v-if="setPay != null" class="pt-5">
                  <div v-if="setPay == 'success'">
                    <img
                      src="@/assets/back-office/check.svg"
                      alt=""
                      width="100vw"
                    />
                  </div>
                  <div v-else>
                    <img
                      src="@/assets/back-office/cancel.svg"
                      alt=""
                      width="100vw"
                    />
                  </div>
                </v-flex>
              </v-layout>
            </v-container>
            <v-card-text class="mb-5">
              <div class="my-2 text-xs-center" v-if="setPay != null">
                <span class="title text-xs-center" v-if="setPay == 'success'"
                  >Success!</span
                >
                <span class="title" v-else>Fail !</span>
              </div>
            </v-card-text>
            <v-footer class="white d-flex justify-end">
              <v-spacer></v-spacer>
              <v-btn
                @click="cancel()"
                class="mb-5"
                dark
                :loading="loadingMessage"
                >Confirm</v-btn
              >
              <v-spacer></v-spacer>
            </v-footer>
          </div>
        </div>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
export default {
  props: ["selectedItem", "AddCreditDialog", "originalUser"],
  data: () => ({
    rules: {
      counter: (value) => value > 0 || "Min 0",
      required: (value) => !!value || "Required.",
    },
    form: {
      managername: "",
      amountcredit: "",
    },
    nextPage: true,
    loadingMessage: false,
    valid: "",
    paynow: true,
  }),
  watch: {
    async AddCreditDialog() {
      this.loadingMessage = true;
      if (this.AddCreditDialog == true) {
        this.getDataMaintain();
      }
      this.loadingMessage = false;
    },
  },
  computed: {
    ...mapState({
      setManagerMaintain: (state) => state.fetchAddcredit.setManagerMaintain,
      setManagerMaintainById: (state) =>
        state.fetchAddcredit.setManagerMaintainById,
      setPay: (state) => state.fetchAddcredit.setPay,
    }),
  },
  methods: {
    ...mapActions({
      fetchManagerMaintain: "fetchAddcredit/fetchManagerMaintain",
      fetchManagerMaintainById: "fetchAddcredit/fetchManagerMaintainById",
    }),
    cancel() {
      this.paynow = true;
      (this.form = {
        managername: "",
        amountcredit: "",
      }),
        (this.nextPage = true);
      this.$emit("setDialog", false);
      this.$refs.form.resetValidation();
    },
    async nextpage(id) {
      if (this.$refs.form.validate()) {
        this.nextPage = false;
        this.loadingMessage = true;
        await this.fetchManagerMaintainById(id);
        this.loadingMessage = false;
      }
    },
    async addCreditComfirm() {
      this.loadingMessage = true;
      this.paynow = false;
      let payload = JSON.parse(JSON.stringify(this.form));
      this.isAdding = true;
      let _this = this;
      this.$emit("onSaved", {
        form: payload,
        done() {
          _this.isAdding = false;
        },
      });
      this.loadingMessage = false;
    },
    async getDataMaintain() {
      this.loadingMessage = true;
      await this.$store.dispatch("fetchAddcredit/fetchManagerMaintain");
      this.loadingMessage = false;
    },
  },
};
</script>
